export class ErrorBase extends Error {
  constructor(e?: string) {
    super(e);
    this.name = new.target.name;
    // 下記の行はTypeScriptの出力ターゲットがES2015より古い場合(ES3, ES5)のみ必要(instanceofがfalseを返すようになるため)
    Object.setPrototypeOf(this, new.target.prototype);
  }
}
